/* eslint-disable camelcase */
import en_US from './en-us';
import es_ES from './es-es';

/** todo envLang will be our environment variable that takes care of
 * languague selection for our build process */
var lang = document.documentElement.lang;
var DEFAULT_LANG = 'en_US';
var langSet = {
	en_US: en_US,
	es_ES: es_ES
};

var selectedLang = langSet[lang] || langSet[DEFAULT_LANG];

export default selectedLang;


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/index.js